import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { AppStorageService } from '../../share/appstorage.service';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from '../../../settings';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  translate: TranslateService;
  languageFromStorage: string;

  constructor(private authService: AuthService,
    private _router: Router,
    private _storage: AppStorageService,
    private _toastr: ToastrService,
    translateService: TranslateService,
    private _settings: AppSettings,
    private _spinner: NgxSpinnerService
    ) {
      this.translate = translateService;
      // this language will be used as a fallback when a translation isn't found in the current language
      translateService.setDefaultLang('en');
      this.languageFromStorage = _storage.getAppsLang();
      if (this.languageFromStorage != null)
        this.setLanguage(this.languageFromStorage);
      else
        this.setLanguage(this._settings.defaultLanguage);
    }


  ngOnInit() {
  }

  private setLanguage(language: string) {
    if (this.languageFromStorage === null)
      this._storage.setAppsLang(language);

    this.translate.use(language);
  }

  onSignin(form: NgForm) {
    this._spinner.show();
    const username = form.value.username;
    const password = form.value.password;
    this.authService.login(username, password).subscribe(
      data => {
        this._storage.setUser(data);
        this._spinner.hide();
        this._router.navigate(['/']);
      },
      err => {
        this._storage.removeUser();
        this.translate.get('Messages.InvalidLogin').subscribe(translated  => {
          this._toastr.error(translated);
        });
        this._spinner.hide();
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/auth/signin/signin.component.ts